/**
 * ### Cancellable Module
 *
 * Http Cancellable request API
 *
 * @author <pino0071@gmail.com> Jose Aburto
 * @version v1
 */
export abstract class Cancellable implements ICancellable {
  protected controller: AbortController;
  protected wasResolved: boolean = false;

  constructor() {
    this.controller = new AbortController();
    this.abort = this.abort.bind(this);
    this.setWasResolved = this.setWasResolved.bind(this);
    this.setAbortController = this.setAbortController.bind(this);
    this.startNewAbortController = this.startNewAbortController.bind(this);
    this.getSignal = this.getSignal.bind(this);
  }

  public setAbortController(controller: AbortController): void {
    this.controller = controller;
  }

  public abort(): void {
    if (!this.wasResolved) {
      this.controller.abort();
    }
  }

  protected startNewAbortController(): void {
    this.controller = new AbortController();
    this.wasResolved = false;
  }

  protected getSignal(): AbortSignal {
    return this.controller.signal;
  }

  protected setWasResolved() {
    this.wasResolved = true;
  }
}

export interface ICancellable {
  setAbortController(controller: AbortController): void;
  abort(): void;
}
